module.exports = __webpack_public_path__ + "static/media/CTLI_9-315w.ace80fde.jpg";